import React, { useState } from 'react';
import { AppBar, IconButton, Menu, MenuItem, Stack, Toolbar, Typography } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import Fetch from '../../script/Fetch';
import { useNavigate } from 'react-router-dom-v5-compat';
import { AccountCircle } from '@mui/icons-material';

interface Props {
    setMobileMenuOpen: (open: boolean) => void;
    mobileMenuOpen: boolean;
}

export const MobileAppBar = (props: Props) => {
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const navigate = useNavigate();

    const handleMenu = (anchor: HTMLElement) => {
        setAnchorEl(anchor);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAccountClick = (event: React.MouseEvent<HTMLElement>) => {
        const anchor = event.currentTarget;
        Fetch.isAuth().then(res => {
            if (res) {
                handleMenu(anchor);
            } else {
                navigate('/login');
            }
        });
    };

    return (
        <AppBar sx={{
            backdropFilter: 'blur(6px)',
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            border: 'none',
            position: 'relative',
        }} variant='outlined'>
            <Toolbar sx={{
                justifyContent: "space-between",
                paddingX: '24px',
                height: 64,
            }}>
                <Stack direction="row" alignItems="center">
                    <img alt="Logo del sito" src="/mascotte-bar.png" style={{ height: 30, marginRight: 10 }} />
                    <img alt="Logo del sito" src="/logo-iammi.png" style={{ height: 30, marginRight: 10 }} />
                </Stack>
                <Stack direction="row" justifyContent="flex-end">
                    <IconButton onClick={() => props.setMobileMenuOpen(!props.mobileMenuOpen)}>
                        <MenuIcon />
                    </IconButton>
                    <IconButton
                        aria-owns={anchorEl ? 'menu-appbar' : undefined}
                        aria-haspopup="true"
                        onClick={handleAccountClick}
                    >
                        <AccountCircle />
                    </IconButton>
                    <Menu
                        id="simple-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem
                            onClick={() => {
                                Fetch.singOut();
                                handleClose();
                            }}
                        >
                            <Typography>Logout</Typography>
                        </MenuItem>
                    </Menu>
                </Stack>
            </Toolbar>
        </AppBar>
    );
}